import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChevronDown, MapPin } from "lucide-react";
import { 
	getStaffOnlineStatus, 
} from "../../../../../redux/dashboard/dashboardState";
import EmployeeProfile from "components/card/EmployeeProfile";

const STATUS_CONFIG = [
  {
    key: "online",
    label: "Online",
    bg: "bg-emerald-500/10 dark:bg-emerald-500/20",
    border: "border-emerald-200 dark:border-emerald-500/30",
    dot: "bg-emerald-500 dark:bg-emerald-400",
    text: "text-emerald-500 dark:text-emerald-400",
  },
  {
    key: "away",
    label: "Away",
    bg: "bg-yellow-500/10 dark:bg-yellow-500/20",
    border: "border-yellow-500/20 dark:border-yellow-500/30",
    dot: "bg-yellow-500 dark:bg-yellow-400",
    text: "text-yellow-500 dark:text-yellow-400",
  },
  {
    key: "offline",
    label: "Offline",
    bg: "bg-gray-500/10 dark:bg-gray-500/20",
    border: "border-gray-500/20 dark:border-gray-500/30",
    dot: "bg-gray-500 dark:bg-gray-400",
    text: "text-gray-500 dark:text-gray-400",
  },
];

const StaffListCard = () => {

  const dispatch = useDispatch();

  const staffLists = useSelector((state) => state.dashboard.staffOnlineStat.items);
  const summary =  useSelector((state) => state.dashboard.staffOnlineStat.summary);
  const loading =  useSelector((state) => state.dashboard.staffOnlineStat.requesting);
  const error = useSelector((state) => state.dashboard.staffOnlineStat.error);

  useEffect(() => {
    dispatch(getStaffOnlineStatus());
  },[dispatch]);

  return (
    <div>
      <div className="grid grid-cols-3 gap-3 mb-6">
        {STATUS_CONFIG.map((status) => (
          <div
            key={status.key}
            className={`flex items-center justify-between p-3 rounded-xl border
              ${status.bg} ${status.border}`}
          >
            <div className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded-full status-dot ${status.dot}`} />
              <span className="text-[13px] font-medium muted-text">
                {status.label}
              </span>
            </div>

            <span className={`text-[18px] font-semibold ${status.text}`}>
              {summary[status.key]}
            </span>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center gap-2 py-2 mb-2">
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full
                        bg-gradient-to-r from-emerald-50 to-purple-50
                        border border-emerald-200 ">
          <span className="text-[11px] font-medium">
            Scroll to view all staff
          </span>
          <ChevronDown className="w-3.5 h-3.5 text-emerald-600 dark:text-emerald-400 animate-bounce" />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 max-h-[51vh] overflow-y-auto">
        {staffLists.map((staff, index) => (
            <div
              key={index}
              className="flex items-center gap-3 p-3 rounded-xl border
                border-slate-200 hover:bg-slate-50 dark:bg-white/10 dark:hover:bg-white/30 
                hover:shadow-md transition-all justify-between"
            >
              <EmployeeProfile 
                record={staff}
                empNameClass="text-[14px] font-semibold truncate title-text"
                withEmpId={false}
                withEmpJobTitle={true}
                empJobTitleClass="text-[12px] muted-text truncate"
                nameInitialBg="bg-green-50 dark:bg-green-100"
                withEmpLocation={true}
              />
              <div className="flex flex-col items-end gap-1">
                <span
                  className={`text-[10px] px-2 py-0.5 text-white status-indicator
                    ${staff?.availability?.toLowerCase()}`}
                >
                  {staff?.availability ?? 'Offline'}
                </span>
                <span className="text-[10px] muted-text ">
                  {staff.lastSeen}
                </span>
              </div>
            </div>
          ))}
      </div>
    </div>
        
  );
};

export default StaffListCard;
